import RmQueryParametersModal from './rm-query-parameters-modal.vue'
export default RmQueryParametersModal
